// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  skinId: "bdtmaster",
  otherKey: 'dev_value',
  // skinId: 'conflux',
  // siteid: 'conflux',  

  api: {
    baseUrl: '',
    // baseUrl: 'https://rrrcasino.com/',
    createMember: "/rest/awesomera/createMember",
    awesomeralogin: "/rest/awesomera/login",
    awesomeraloginAndlaunch: "/rest/awesomera/loginAndlaunch",
    JT: "/rest/gameLaunch/JTintegration/",
    Live_dealer: "/rest/gameLaunch/JTintegration/",
    login: "/api/player/login",
    randomLogin: "/api/player/randomLogin",
    randomPass: "/api/player/randomPass",
    // ezugi: "/rest/ezugi/handler/",
    ezugi: "rest/ezugi/session",
    evogames: "/rest/ezugi/evo/session",
    pragmatictoken: "/rest/pp/ppToken",
    mancalagameurl: "/rest/mancala/getToken",
    // vivoslots: "/api/playVivo/handler/vivo",
    bubyplayurl: "/rest/ruby_play/launch",
    vibraurl: "/rest/vibra/launch",
    lottery: "/rest/wearelotto/launchGame",
    vivoslots: "/rest/vivo/balance_integration/vivoGaming",
    vivoslots1: "/api/playVivo/handler/vivo",
    // evogames:"/rest/ezugi/evo/session",
    lotteryUrl: "/rest/fawk/handler/",
    livedealer: "/api/Vivo/freshDeck/handler",
    fawkgame: "fawkGames.json",
    auraGame: 'rest/fawk/handler',
    arcades: "/rest/arcades/handler/",
    heblounch: "/rest/habanero/session",
    indiecasino: "/rest/indiCasino/api/handler",
    endrophi: '/rest/endorphina/endorphinaUrl',
    gameurl: "/rest/caballonegro",
    vivourl: "api/Vivo/handler",
    kagame: "rest/kagaming/launchGame",
    gvprovider: "/rest/gv/request/launchGame",
    huidu_api: "/rest/huidu/launchGame",

    // heblounch: "/rest/habanero/handler",
    hebfunlounch: "/rest/habanero/habFunMode",
    generateCaptcha: "/api/player/generateCaptcha",
    logout: "/api/player/logout",
    register: "/api/player/register",
    getCountries: "/api/player/getCountries",
    fotgotPassword: "/api/player/forgotPassword",
    sportoken: "/rest/powerPlay/launch",
    sportsbook: "/rest/bti/btiToken",

    // generateOTP: "/api/player/generateOTP",
    generateOTP: 'api/player/generateOTP',
    validOTP: 'api/player/validateOTP',
    uploadFiles: "/api/player/uploadFile",
    getDocuments: "/api/player/getDocuments",
    leaderboardList: "/api/leaderboard/list",
    getParticipants: "/api/leaderboard/getParticipants",
    remotelogin: "/sbapi/auth/remote",
    contactus: "api/player/contactUs",
    allGamesUrl: "/api/player/mrGameURL",
    getHitCountSummary: "api/affiliateHistory/getHitCountSummary",
    allGamesfunUrl: "rest/mrslotty/mrGameFunURL",
    allNewGamesfunUrl: "rest/mrslotty/allNewGamesfunUrl",
    paymentMethi: "/api/cashier/getPaymentMethods",
    getpermissionData: "/api/player/getPlayerProviderList",
    getprovidersbeforelogin: "/api/agentAccount/getProviders",
    jdbLaunch: "rest/jdb/gameLaunch",
    newEzugievo: "/rest/api/gad/gameLaunchUrl",
    aviatrix: "/rest/aviatrix/launchGame",
    getAvatarList: "/api/player/getAvatarList",
    getAvatar: "/api/player/getAvatar",
    setAvatar: "/api/player/setAvatar",
    setFavoutite: '/api/player/saveFavouriteGames',
    getFavoutite: '/api/player/getFavouriteGames',
    deleteFavouriteGame: '/api/player/deleteFavouriteGame',
    getCoinPaymentConverstionRate: `/api/cashier/getCoinPaymentConversionRate?from=ETH&to=${sessionStorage.getItem('wallet')}`,


    // generateTokenClan: '/api/clanmgr/generateToken',
    generateTokenClan: '/api/clanmgr/getClanSystem',
    webAuthVerify: '/api/player/webAuth/verify',

    launchGame: '/rest/onegamehub/launchGame',
    launchJill: "/rest/jilli/launchGame",

    player: {
      playerBonuswager: "api/cashier/getPlayerWageringInfo",
      mPlayUrl: "/api/player/mPlayGameURL",
      captchaAuth: "/api/player/auth-url",
      getProfile: "/api/player/getProfile",
      updateProfile: "/api/player/updateProfile",
      updatePassword: "/api/player/updatePassword",
      verifyAccount: "/api/player/verifyAccount",
      resendToken: "/api/player/resendToken",
      getLaunchURLS: "/api/player/getLaunchURLS",
      resetPassword: "/api/player/resetPassword",
      tournamentsList: "/api/player/getPokerTournamentsList",
      playerStats: "/api/player/getStats",
      playerCurrencies: "/api/player/getCurrencies",
      games: "/api/player/getGames",
      playerLevels: "/api/cp/playerLevels",
      exchangeRates: "/api/cp/exchangeRates",
      getExchangeRates: "/api/cp/exchangeRates",
      exchangeVipPointsUrl: "/api/cp/exchange",
      exchange: "/api/cp/exchange",
      contactus: "api/player/contactUs",
      endsession: "/rest/torrospin/endSession",
      kingmidas: "/rest/kingmidas/launchGame",

      playerGameHistory: "api/player/playerGameHistory",
      getTorrospinGameLaunch: "/rest/torrospin/launchGame",
      gameClose: "/rest/torrospin/gameClosed",
      closeGameSession: "/api/player/closeSession",

      playerStatistics: "api/player/getPlayerStatistics"
    },
    cashier: {
      balance: "/api/cashier/balance",
      crypto: "/api/cashier/getCoinPaymentCurrencyId",
      resetPlayMoneyBalance: "/api/cashier/resetPlayMoneyBalance",
      getPaymentSystems: "/api/cashier/getPaymentSystems?pgid=",
      depositSystems: "/api/cashier/depositSystems",
      withdrawSystems: "/api/cashier/getCashOutInfo",
      withDrawCashout: "/api/cashier/cashout",
      deposit: "/api/cashier/buy",
      getOpenWithdrawRequests: "/api/cashier/getOpenWithdrawRequests",
      cancelWithdrawRequest: "/api/cashier/cancelWithdrawRequest",
      withdraw: "/api/cashier/cashout",
      addBankAccount: "/api/cashier/addBankAccount",
      getBankAccounts: "/api/cashier/getBankAccounts",
      deleteBankAccounts: "/api/cashier/deleteBankAccounts",
      DepositCallBack: "/api/cashier/depositCallBack",
      interKassaCashOut: "/api/cashier/interKassaCashout",
      depositepostbackurl: "/api/cashier/depositCallBackStatus",
      ActivePromoCodes: "/api/player/getActivePromoCodes",

      exchangRates: '/api/cashier/getExchangeRates',
      walletExchange: '/api/cashier/walletExchange',

      wageringInfo: 'api/cashier/getPlayerWageringInfo'
    },
    history: {
      transaction: "/api/history/transactionCheck",
      game: "/api/history/game",
      remotegame: "/api/history/remoteGames",
    },
    sports: {
      sportsList: "/sbapi/sports/matches/no",
      "9wkt": "/rest/huidu/9wkt/launchGame",
       "walletupdate": "/rest/huidu/9wkt/walletupdate",
      leaguesList: "/sbapi/sports/sportleagues",
      leaguesandmatchList: "/sbapi/sports/prematch",
      getleagueById: "/sbapi/sports/leagues",
      betslip: "/sbapi/bets/betslip",
      anonymousbet: "/sbapi/bets/anonymousbet",
      bonus: "/sbapi/bets/bonus",
      betsByCoupon: "/sbapi/bets/coupon",
      emailTicket: "/rest/bet/email/ticket",
      betHistory: "/sbapi/bets/getbets",
      freshdeck: "api/Vivo/freshDeck/handler",
    },
  },

  socketConfig: {
    url: "http://10.10.20.201:9000",
    opts: {
      transports: ["websocket"],
      path: "/ws/poker-ssl",
      query: {
        EIO: "3",
      },
    },
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error'; // Included with Angular CLI.
